// extracted by mini-css-extract-plugin
export var brand = "_1s-9";
export var button = "_1s-0";
export var chevron = "_1s-v";
export var chevronButton = "_1s-w";
export var content = "_1s-n";
export var danger = "_1s-g";
export var dangerOutlined = "_1s-h";
export var dark = "_1s-l";
export var darkTheme = "_1s-c";
export var extraSmall = "_1s-4";
export var fullWidth = "_1s-8";
export var ghost = "_1s-d";
export var gray = "_1s-t";
export var icon = "_1s-p";
export var iconButton = "_1s-s";
export var iconButtonBorder = "_1s-x";
export var iconButtonBorderDark = "_1s-y";
export var iconButtonBorderLight = "_1s-z";
export var iconLeft = "_1s-q";
export var iconRight = "_1s-r";
export var large = "_1s-1";
export var light = "_1s-m";
export var medium = "_1s-2";
export var micro = "_1s-5";
export var nano = "_1s-7";
export var outlined = "_1s-k";
export var pending = "_1s-a";
export var primary = "_1s-i";
export var shadow = "_1s-o";
export var small = "_1s-3";
export var solidLight = "_1s-e";
export var solidLightBrand = "_1s-f";
export var spinner = "_1s-u";
export var transparent = "_1s-j";
export var warning = "_1s-b";
export var wideNano = "_1s-6";